import * as homePage from './homePage/reducer'


export default {
  homePage,
}
